function hashCode(str: string) {
  let hash = 0;
  for (let i = 0; i < str?.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return hash;
}

export function generateNumberBasedOnId(id: number, min: number, max: number) {
  const hash = hashCode(id?.toString());
  const primeMultiplier = 37;
  const randomValue = Math.abs((hash * primeMultiplier) % (max - min + 1));
  return min + randomValue;
}
